import styles from './RouteLoadingSkeleton.module.css';

export type RouteLoadingSkeletonProps = {
  rows?: number;
};

/**
 * FE-41 — pendingComponent skeleton для TanStack Router route transitions.
 * Shows immediately when route transition starts and outlasts pendingMs (200ms).
 * Layout = h1 placeholder + 4-6 row table shimmers.
 *
 * Связан с feedback_ui_route_transition: пользователь не должен видеть
 * stale content предыдущего route во время async data load.
 */
export function RouteLoadingSkeleton({ rows = 5 }: RouteLoadingSkeletonProps): JSX.Element {
  return (
    <div className={styles.wrap} aria-busy="true" aria-live="polite">
      <div className={styles.h1} />
      <div className={styles.toolbar}>
        <div className={styles.chip} />
        <div className={styles.chip} />
        <div className={styles.search} />
      </div>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className={styles.row}>
          <div className={styles.cellSm} />
          <div className={styles.cell} />
          <div className={styles.cellSm} />
          <div className={styles.cellSm} />
          <div className={styles.cellSm} />
        </div>
      ))}
    </div>
  );
}
